import React from 'react';

export default function Image({ slice }) {
  return <div className="blog-body2-image">{<img src={slice.primary.blog_images.fluid.src} alt="hello" />}</div>;
}
